// import React, { useState, useEffect, useContext } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import LocContext from '../context/locContext'; // adjust path if needed
// import ClientNavbar from '../layout/ClientNavbar';

// export default function ClientMutualFunds() {
//   const { userData } = useContext(LocContext); // get logged-in user data
//   const id = userData?.id;

//   const [userDataP, setUserDataP] = useState({});
//   const [data, setData] = useState([]);

//   // Fetch mutual funds
//   const getFundsData = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund`);
//       if (res.status === 200) setData(res.data.data);
//       else setData([]);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // Fetch user data
//   const getUserData = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/${id}`);
//       if (res.status === 200) setUserDataP(res.data.data);
//       else setUserDataP({});
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     getFundsData();
//     if (id) getUserData();
//   }, [id]);

//   return (
//     <div>
//     <ClientNavbar />

//       <div className="card shadow-sm p-4 mb-4">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="text-primary mb-0">Available Mutual Funds</h3>
//           <Link
//             to={
//               userData?.mutual_status === 1
//                 ? "https://gpsfinvest.investwell.app/app/#/login"
//                 : "/Invest-application"
//             }
//           >
//             <button className="btn btn-primary">Invest Now</button>
//           </Link>
//         </div>

//         <div className="row g-3">
//           {data.map((fund) => (
//             <div key={fund.id} className="col-md-6 col-lg-4">
//               <div className="card h-100 p-3 shadow-sm">
//                 <h5 className="text-primary mb-2">{fund.name}</h5>
//                 <p className="mb-1">
//                   <small className="text-muted">Category:</small> {fund.category}
//                 </p>
//                 <p className="mb-1">
//                   <small className="text-muted">Risk Level:</small> {fund.risk}
//                 </p>
//                 <p className="mb-1">
//                   <small className="text-muted">Expected Returns:</small>{" "}
//                   <span className="text-teal fw-bold">{fund.returns}%</span>
//                 </p>
//                 <p className="mb-3">
//                   <small className="text-muted">Min SIP:</small> ₹{fund.nav}
//                 </p>
//                 <Link
//                   to={
//                     userDataP?.mutual_status === 1
//                       ? "https://gpsfinvest.investwell.app/app/#/login"
//                       : "/Invest-application"
//                   }
//                 >
//                   <button className="btn btn-primary w-100">
//                     Invest in this Fund
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import LocContext from "../context/locContext"; // adjust path if needed
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

export default function ClientMutualFunds() {
  const { userData } = useContext(LocContext); // get logged-in user data
  const id = userData?.id;

  const [userDataP, setUserDataP] = useState({});
  const [data, setData] = useState([]);

  // Fetch mutual funds
  const getFundsData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund`,
      );
      if (res.status === 200) setData(res.data.data);
      else setData([]);
    } catch (err) {
      console.log(err);
    }
  };

  // Fetch user data
  const getUserData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/user/${id}`,
      );
      if (res.status === 200) setUserDataP(res.data.data);
      else setUserDataP({});
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFundsData();
    if (id) getUserData();
  }, [id]);

  // categories list (title + optional dummy meta)
  const categories = [
    { key: "all", title: "All", risk: "Moderate", returns: "10.10%", link: "All" },
    { key: "debt", title: "Debt", risk: "Moderate", returns: "8.00%", link: "Debt" },
    { key: "equity", title: "Equity", risk: "High", returns: "12.40%", link: "Equity" },
    { key: "hybrid", title: "Hybrid", risk: "Moderate", returns: "9.15%", link: "Hybrid" },
    { key: "sif", title: "SIF", risk: "Moderate", returns: "9.15%", link: "SIF" },
    { key: "Solution", title: "Solution", risk: "Low", returns: "6.25%", link: "Solution" },
    { key: "Gold", title: "Gold", risk: "Low", returns: "4.20%", link: "Gold", },
    { key: "other", title: "Other", risk: "Variable", returns: "N/A", link: "Others" },
  ];

  const investLink =
    userDataP?.mutual_status === 1
      ? "https://gpsfinvest.investwell.app/app/#/login"
      : "/Invest-application";

  return (
    <>
      <style>{`
      h3 a:hover {
  text-decoration: underline;
}
        /* Category card container */
        .categories-wrap {
          background: #ffffff;
          border-radius: 12px;
          padding: 18px;
          box-shadow: 0 8px 30px rgba(3, 186, 187, 0.06);
        }

        .category-card {
          border-radius: 10px;
          transition: transform .18s ease, box-shadow .18s ease;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 170px;
          background: linear-gradient(180deg, #ffffff 0%, #fbffff 100%);
          border: 1px solid rgba(0,0,0,0.03);
        }

        .category-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 30px rgba(12,60,84,0.06);
        }

        .category-title {
          font-size: 1rem;
          color: #0d9488; /* teal-ish */
          font-weight: 700;
          margin-bottom: 6px;
        }
        .category-meta {
          font-size: .88rem;
          color: #6b7280;
          margin-bottom: 8px;
        }
        .category-stat {
          font-size: .92rem;
          font-weight: 600;
          color: #0f766e;
        }

        /* Buttons row inside card */
        .btn-row {
          margin-top: 10px;
        }
        .btn-row .btn {
          padding: .45rem .6rem;
          font-size: .86rem;
        }

        /* Make view details outline */
        .btn-outline-custom {
          border: 1px solid rgba(15,118,110,0.12);
          color: #0f766e;
          background: transparent;
        }

        /* Responsive tuning */
        @media (max-width: 575.98px) {
          .category-card { min-height: 150px; padding: 12px; }
          /* stack buttons on very small screens */
          .btn-row .col-6 { flex: 0 0 100%; max-width: 100%; }
          .btn-row .col-6 + .col-6 { margin-top: 8px; }
        }
      `}</style>

      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>

            <div className="card shadow-sm p-4 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h3 className="text-primary mb-0">Available Mutual Funds</h3>

              <Link to={investLink}>
                <button className="btn btn-primary">Invest Now</button>
              </Link>
            </div>
            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Available Mutual Funds
                </li>
              </ol>
            </nav>
            </div>

            {/* Categories area */}
            <div className="categories-wrap mb-4">
              <div className="row gy-3">
                {categories.map((c) => (
                  <div
                    key={c.key}
                    className="col-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <div className="category-card p-3 h-100">
                      <div>
                        <div className="category-title">{c.title}</div>
                        <div className="category-meta">
                          <small className="text-muted">Risk Level:</small>
                          <span className="category-stat">{c.risk}</span>
                        </div>

                        {/* Optional extra line like Expected Returns */}
                        <div className="category-meta">
                          <small className="text-muted">
                            Expected Returns:
                          </small>
                          <span className="category-stat">{c.returns}</span>
                        </div>
                      </div>

                      {/* Buttons row - stays in one row on most screens */}
                      <div className="row g-2 btn-row">
                        <div className="col-6">
                          <Link to={investLink}>
                            <button className="btn btn-primary w-100 btn-sm">
                              Invest Here
                            </button>
                          </Link>
                        </div>

                        <div className="col-6">
                          {/* <Link to="/ClientViewDetail">
                            <button className="btn btn-sm w-100 btn-outline-custom">
                              View Details
                            </button>
                          </Link> */}
                          <Link
                            to="/ClientViewDetail"
                            state={{ category: c.link }}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <div className="btn btn-sm w-100 btn-outline-custom">
                              View Details
                            </div>
                          </Link>

                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dynamic mutual funds list (kept commented in your original) */}
            {/* <div className="row g-3">
              {data.map((fund) => (
                <div key={fund.id} className="col-md-6 col-lg-4">
                  <div className="card h-100 p-3 shadow-sm">
                    <h5 className="text-primary mb-2">{fund.name}</h5>
                    <p className="mb-1">
                      <small className="text-muted">Category:</small>{" "}
                      {fund.category}
                    </p>
                    <p className="mb-1">
                      <small className="text-muted">Risk Level:</small>{" "}
                      {fund.risk}
                    </p>
                    <p className="mb-1">
                      <small className="text-muted">Expected Returns:</small>{" "}
                      <span className="fw-bold">{fund.returns}%</span>
                    </p>
                    <p className="mb-3">
                      <small className="text-muted">Min SIP:</small> ₹{fund.nav}
                    </p>

                   <Link to={ userData?.mutual_status === 1 ? "https://gpsfinvest.investwell.app/app/#/login" : "/Invest-application" } >
                      <button className="btn btn-primary w-100 mb-2">Invest Here</button>
                    </Link>
                    <Link to={investLink}>
                      <button className="btn btn-outline-primary w-100">View Details</button>
                    </Link>
                  </div>
                </div>
              ))}
            </div> */}
          </div>
    
    </>
  );
}
